/** Shared metric grid sizing — keep Legend + TeamCard aligned (bb-grid parity). */

export interface GridCellLayout {
  cellSize: string;
  legendRowHeight: string;
  labelWidth: string;
  metricGap: string;
  columnGap: string;
  cardClassName: string;
  legendPaddingTop: string;
  legendIconClass: string;
  legendLabelClass: string;
  rankBadgeTop: string;
  rankBadgeClass: string;
  footerMarginTop: string;
  footerGap: string;
}

export function getGridCellLayout(options: {
  tvMode: boolean;
  showValues: boolean;
  showPeriodLabels: boolean;
}): GridCellLayout {
  const { tvMode, showValues, showPeriodLabels } = options;

  return {
    // TV + metrics: 68px cells (was 72) so 3 cards + legend fit a 1280px frame.
    // TV without metrics: h-12 cells so 2 rows + headshots fit 1080p displays.
    cellSize: tvMode
      ? showValues
        ? "h-16 w-[68px]"
        : "h-12 w-12"
      : showValues
        ? "h-11 w-12"
        : "h-9 w-9",
    legendRowHeight: tvMode ? (showValues ? "h-16" : "h-12") : showValues ? "h-11" : "h-9",
    labelWidth: tvMode ? (showValues ? "w-[68px]" : "w-12") : showValues ? "w-12" : "w-9",
    metricGap: tvMode ? "gap-1.5" : "gap-1",
    columnGap: tvMode ? "gap-2" : "gap-1.5",
    cardClassName: tvMode ? "gap-4 px-4 pb-3 pt-6" : "gap-3 px-3 pb-3 pt-5",
    legendPaddingTop: showPeriodLabels
      ? tvMode
        ? "pt-[52px]"
        : "pt-[42px]"
      : tvMode
        ? "pt-6"
        : "pt-5",
    legendIconClass: tvMode ? "h-5 w-5" : "h-3.5 w-3.5",
    legendLabelClass: tvMode ? "text-xs" : "text-[10px]",
    rankBadgeTop: tvMode ? "-top-3" : "-top-2.5",
    rankBadgeClass: tvMode ? "px-2.5 py-1 text-xs" : "px-2 py-0.5 text-[10px]",
    footerMarginTop: tvMode ? "mt-3" : "mt-3",
    footerGap: tvMode ? "gap-1.5" : "gap-1.5",
  };
}
